var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"custom-icon",attrs:{"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.293 5.293a1 1 0 1 1 1.414 1.414l-5 5a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414L8 9.586l4.293-4.293z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }